<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="postTitle">
                <span slot="label" ><a-tooltip>{{ $t('帖子标题') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.postTitle" :maxLength="32" :placeholder="$t('请输入')+'帖子标题'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item prop="addressDetail">
                  <span slot="label" ><a-tooltip>{{ $t('详细地址') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.addressDetail" :maxLength="32" :placeholder="$t('请输入')+'详细地址'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="viewNum">
                  <span slot="label" ><a-tooltip>{{ $t('浏览数量') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.viewNum" :maxLength="32" :placeholder="$t('请输入')+'浏览数量'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="starNum">
                  <span slot="label" ><a-tooltip>{{ $t('点赞数量') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.starNum" :maxLength="32" :placeholder="$t('请输入')+'点赞数量'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="replyNum">
                  <span slot="label" ><a-tooltip>{{ $t('评论数量') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.replyNum" :maxLength="32" :placeholder="$t('请输入')+'评论数量'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="collectionNum">
                  <span slot="label" ><a-tooltip>{{ $t('收藏数量') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.collectionNum" :maxLength="32" :placeholder="$t('请输入')+'收藏数量'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="shareNum">
                  <span slot="label" ><a-tooltip>{{ $t('分享数量') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.shareNum" :maxLength="32" :placeholder="$t('请输入')+'分享数量'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="goodsNum">
                  <span slot="label" ><a-tooltip>{{ $t('关联商品数量') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.goodsNum" :maxLength="32" :placeholder="$t('请输入')+'关联商品数量'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="isTop">
                  <span slot="label" ><a-tooltip>{{ $t('是否置顶') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.isTop" :maxLength="32" :placeholder="$t('请输入')+'是否置顶'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="isRecommend">
                  <span slot="label" ><a-tooltip>{{ $t('是否推荐') }}<template slot="title">{{ $t('是否推荐') }}</template></a-tooltip> </span>
                  <a-select v-model="queryParam.isRecommend" :placeholder="$t('请选择')+'是否推荐'" allow-clear @change="handleQuery">
                    <a-select-option :value="false">{{ $t('不推荐') }}</a-select-option>
                    <a-select-option :value="true">{{ $t('推荐') }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createBeginTime"
                    :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createEndTime"
                    :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communitygrouppost:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communitygrouppost:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 3150 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="postType" slot-scope="text">{{ postTypeMap[text] || text }}</span>
        <span slot="postStatus" slot-scope="text">{{ postStatusMap[text] || text }}</span>
        <span slot="coverUrl" slot-scope="text, record">
          <div>
            <img v-if="record.coverUrl" :src="record.coverUrl" style="width:60px;height:60px;border-radius:4px;object-fit:cover;" alt="none"/>
          </div>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isRecommend" slot-scope="text, record">
          <a-switch :disabled="!hasPermi('community:communitygrouppost:edit')" @change="(checked) => onStatusChange(checked, record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isRecommend"/>
        </span>
        <span slot="isTop" slot-scope="text, record">
          <a-switch :disabled="!hasPermi('community:communitygrouppost:edit')" @change="(checked) => onTopChange(checked, record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isTop"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['community:communitygrouppost:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communitygrouppost:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityGroupPost, delCommunityGroupPost, updateCommunityGroupPostRecommend, updateCommunityGroupPostTop } from '@/api/community/communityGroup/communityGroupPost'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityGroupPost',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 帖子类型/状态中文映射
      postTypeMap: { 10: '文字', 20: '图文', 30: '视频' },
      postStatusMap: { 1010: '审核通过', 1020: '待审核', 1030: '审核拒绝', 1040: '已下架', 1050: '草稿' },
      // 查询参数
      queryParam: {
        postTitle: undefined,
        postContent: undefined,
        postType: undefined,
        coverUrl: undefined,
        addressDetail: undefined,
        viewNum: undefined,
        starNum: undefined,
        replyNum: undefined,
        collectionNum: undefined,
        shareNum: undefined,
        goodsNum: undefined,
        isTop: undefined,
        isRecommend: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('所属小组'),
          dataIndex: 'groupId',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('发布用户'),
          dataIndex: 'userId',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('帖子标题'),
          dataIndex: 'postTitle',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('帖子正文'),
          dataIndex: 'postContent',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('帖子类型'),
          dataIndex: 'postType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'postType' }
        },
        {
          title: this.$t('帖子状态'),
          dataIndex: 'postStatus',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'postStatus' }
        },
        {
          title: this.$t('帖子封面'),
          dataIndex: 'coverUrl',
          width: 200,
          align: 'center',
          scopedSlots: { customRender: 'coverUrl' }
        },
        {
          title: this.$t('详细地址'),
          dataIndex: 'addressDetail',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('定位经度'),
          dataIndex: 'addressLongitude',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('定位纬度'),
          dataIndex: 'addressLatitude',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('浏览数量'),
          dataIndex: 'viewNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('点赞数量'),
          dataIndex: 'starNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('评论数量'),
          dataIndex: 'replyNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('收藏数量'),
          dataIndex: 'collectionNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('分享数量'),
          dataIndex: 'shareNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('关联商品数量'),
          dataIndex: 'goodsNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('是否置顶'),
          dataIndex: 'isTop',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'isTop' }
        },
        {
          title: this.$t('是否推荐'),
          dataIndex: 'isRecommend',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'isRecommend' }
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    hasPermi(permission) {
      // 与后端 @SaCheckPermission 保持一致，无编辑权限时禁用“是否推荐”开关
      const allPermission = '*:*:*'
      const permissions = this.$store.getters.permissions || []
      return permissions.some(item => item === allPermission || item === permission)
    },
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 更新社区小组帖子置顶状态 */
    onTopChange(checked, record) {
      updateCommunityGroupPostTop({ id: record.id, isTop: checked }).then(response => {
        if (response.success) {
          record.isTop = checked
          this.$message.success(this.$t('修改成功'), 3)
        }
      })
    },
    /** 更新社区小组帖子推荐状态 */
    onStatusChange(checked, record) {
      updateCommunityGroupPostRecommend({ id: record.id, isRecommend: checked }).then(response => {
        if (response.success) {
          record.isRecommend = checked
          this.$message.success(this.$t('修改成功'), 3)
        }
      })
    },
    /** 查询社区小组帖子列表 */
    getList () {
      this.loading = true
     pageCommunityGroupPost(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        postTitle: undefined,
        postContent: undefined,
        postType: undefined,
        coverUrl: undefined,
        addressDetail: undefined,
        viewNum: undefined,
        starNum: undefined,
        replyNum: undefined,
        collectionNum: undefined,
        shareNum: undefined,
        goodsNum: undefined,
        isTop: undefined,
        isRecommend: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      const reqData = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityGroupPost(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message, 3)
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/community/community/group/post/export',
            that.queryParam
          , `社区小组帖子_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
   }
 }
}
</script>
